import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Button, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import { useProblemsConstraints } from "../../../../../hooks/useDataHooks"; // Updated hook import
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";

const title = { xxl: 4, xl: 4, lg: 4, md: 5, sm: 10, xs: 0 };
const descriptions = { xxl: 3, xl: 3, lg: 3, md: 0, sm: 0, xs: 0 };
const issue_management_activities = {
  xxl: 4,
  xl: 4,
  lg: 4,
  md: 5,
  sm: 0,
  xs: 0,
};
const status = {
  xxl: 4,
  xl: 4,
  lg: 4,
  md: 5,
  sm: 10,
  xs: 0,
};
const recommendation = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 0, xs: 0 };

const headerLayout = [
  { ...title, header: "Title" },
  { ...descriptions, header: "Description" },
  { ...issue_management_activities, header: "Issue Management Activities" },
  { ...status, header: "Status" },
  { ...recommendation, header: "Recommendation" },
];

const ProblemsConstraints = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  // Use the correct hook to fetch problemsConstraints data
  const { problemsConstraints, loading } = useProblemsConstraints(
    packageId,
    startDate,
    endDate
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
    setActiveItem(null);
  };

  const history = useHistory();
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";

  return (
    <>
      <div>
        <Button onClick={() => history.goBack()} type="primary">
          <ArrowLeftOutlined />
          Back
        </Button>
        {/* CustomList for Problems Constraints */}
        <CustomList
          itemName={`Problems Constraints`}
          title={`${packageName}: Problems Constraints`}
          actionButtonProp={{ title: `${packageName}: Problems Constraints` }}
          items={problemsConstraints || []} // Use empty array if problemsConstraints is null/undefined
          page={1}
          itemCount={problemsConstraints?.length ?? 0} // Safely check length
          loading={loading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id}
              name={item?.title || "no title"}
              item={item}
              renderActions={() => {}}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.title === item.title ? "#f0f0f0" : "transparent",
              }}
            >
              {/* Render each column value from item */}
              <Col
                {...title}
                className="contentEllipse"
                title={item?.title || "-"}
              >
                {item?.title || "-"}
              </Col>
              <Col
                {...descriptions}
                className="contentEllipse"
                title={item?.description || "-"}
              >
                {item?.description || "-"}
              </Col>
              <Col
                {...issue_management_activities}
                className="contentEllipse"
                title={item?.issue_management_activities || "-"}
              >
                {item?.issue_management_activities || "-"}
              </Col>
              <Col
                {...status}
                className="contentEllipse"
                title={item?.status || "-"}
              >
                {item?.status || "-"}
              </Col>
              <Col
                {...recommendation}
                className="contentEllipse"
                title={item?.recommendation || "-"}
              >
                {item?.recommendation || "-"}
              </Col>
            </ListItem>
          )}
        />
      </div>

      <Drawer
        title="Problem Constraint Details"
        placement="right"
        closable={true}
        onClose={handleCloseDrawer}
        visible={visible}
        width={720}
      >
        {activeItem && (
          <>
            <p>
              <strong>Title:</strong> {activeItem?.title || "-"}
            </p>
            <p>
              <strong>Description:</strong> {activeItem?.description || "-"}
            </p>
            <p>
              <strong>Issue Management Activities:</strong>{" "}
              {activeItem?.issue_management_activities || "-"}
            </p>
            <p>
              <strong>Status:</strong> {activeItem?.status || "-"}
            </p>
            <p>
              <strong>Recommendation:</strong>{" "}
              {activeItem?.recommendation || "-"}
            </p>
          </>
        )}
      </Drawer>
    </>
  );
};

export default ProblemsConstraints;
